import { useRevealOnScroll } from "@/hooks/use-reveal-on-scroll";
import { AGAVE_FIELD } from "@/lib/sps-content";
import { ArrowRight } from "lucide-react";

export const About = () => {
  useRevealOnScroll();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-white"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[700px]">
        {/* LEFT — text */}
        <div className="flex items-center px-6 md:px-12 lg:px-24 py-20 md:py-28 lg:py-32 reveal">
          <div className="max-w-xl">
            <img
              src="https://customer-assets.emergentagent.com/job_spirits-production/artifacts/4pil9jqk_SPT_Mesa%20de%20trabajo%201.webp"
              alt="SPS"
              className="h-10 w-auto object-contain mb-10"
            />
            <h2
              data-testid="about-title"
              className="font-sans-modern font-light text-[#001825] text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight uppercase"
            >
              Transformamos
              <br />
              el agave en historias que trascienden.
            </h2>

            <p
              data-testid="about-description"
              className="mt-10 text-[#3a4651] text-base md:text-lg leading-relaxed font-light font-sans-modern"
            >
              Somos un grupo corporativo que opera soluciones integrales para la
              transformación del Agave. Mediante unidades especializadas,
              garantizamos el control, consistencia y trazabilidad en procesos
              de destilación, embotellado y desarrollo de nuevos productos
              derivados del Agave, impulsando un modelo responsable con la
              industria, el entorno y nuestra comunidad.
            </p>

            <div className="mt-10">
              <button
                data-testid="about-cta"
                onClick={() => scrollTo("servicios")}
                className="group inline-flex items-center gap-4 px-8 py-4 bg-[#002438] border border-[#002438] text-white text-xs uppercase tracking-[0.25em] hover:bg-[#001825] hover:border-[#001825] transition-all duration-300"
              >
                Conoce nuestros servicios
                <ArrowRight
                  size={16}
                  strokeWidth={1.5}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT — agave photo with frame + rounded corners */}
        <div className="relative min-h-[420px] lg:min-h-0 reveal p-5" style={{ transitionDelay: "120ms" }}>
          <img
            src={AGAVE_FIELD}
            alt="Campo de agave"
            className="w-full h-full object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};
